document.addEventListener('turbolinks:load', () => {
    const guidedQuizPreview = document.getElementById('guidedQuizPreview')
    const sgScreen = document.getElementById('sgScreen')
    const quizDeselectAll = document.getElementById('quizDeselectAll')
    const quizSelectAll = document.getElementById('quizSelectAll')
    const guideQuestionSelectForm = document.getElementById('guideQuestionSelectForm')
    const guideQuestionSelectStartQuiz = document.getElementById('guideQuestionSelectStartQuiz')

    let checkBoxes

    if (guidedQuizPreview !== null && sgScreen !== null && guideQuestionSelectForm !== null &&
        quizSelectAll !== null && quizDeselectAll !== null && guideQuestionSelectStartQuiz !== null) {
        checkBoxes = sgScreen.getElementsByClassName('myTourQuizCheckBox')

        initCheckboxes()
        quizSelectAll.addEventListener('click', selectAll)
        quizDeselectAll.addEventListener('click', deselectAll)
        guideQuestionSelectStartQuiz.addEventListener('click', checkAndSubmit)
    }

    function initCheckboxes() {
        for (let c of checkBoxes) {
            customCheckbox(c) // initialize checkboxes


            c.addEventListener('change', function() {
                customCheckbox(c)
            })
        }
    }

    // add the background image on changing
    function customCheckbox(c){
        if (c.checked) {
            const color = '#1c5fa5' // use '#9ca3af' if solution_screen is shown
            c.style.borderColor = color
            c.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${color.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
        } else {
            c.style.backgroundImage = 'none'
            c.style.borderColor = c.dataset.color // entspricht gray-200 | use #9ca3af if solution_screen is shown
        }
    }

    function selectAll(){
        for (let c of checkBoxes) {
            c.checked = true
            customCheckbox(c) // use checkbox function cause change don't get fired on JS change
        }
    }

    function deselectAll(){
        for (let c of checkBoxes) {
            c.checked = false
            customCheckbox(c) // use checkbox function cause change don't get fired on JS change
        }
    }

    function checkAndSubmit(){
        let oneSelected = false
        for (let c of checkBoxes) {
            if(c.checked){
                oneSelected = true
                break
            }
        }
        if(oneSelected){
            guideQuestionSelectForm.submit()
        }
    }
})